export default __webpack_public_path__ + "static/media/primary-error.38bdbe80.svg";